import { getCSRFToken } from '@shared/cookie';
import createOneClickForm from '@shared/local-jobs-one-click-form';

export function createPostForm(formId) {
  const domForm = document.getElementById(formId);
  const oneClickForm = createOneClickForm(formId);
  // Original form should work without loading JS.
  // This changes the behavior and contents of post project form
  // to enable one-click functionality.
  domForm.action = '/buyers/on-local-one-click.php';
  domForm.method = 'POST';

  oneClickForm.createHiddenField('csrf_token', getCSRFToken());

  return {
    submit: oneClickForm.submit,
    setLocation: oneClickForm.setLocation,
    setEmail: oneClickForm.setEmail,
    setNewUserName: oneClickForm.setNewUserName,
    setNewPassword: oneClickForm.setNewPassword,
    setSubCategory: oneClickForm.setSubCategory,
    fields: oneClickForm.fields,
  };
}
